/**
 * Slugify — the browser copy of services/util/slug.js.
 *
 * Duplicated rather than shared because the server module is CommonJS inside the API
 * process; this is a handful of lines and bundling the server tree to avoid it would cost
 * far more than it saves. The two implementations MUST stay identical — if you change one,
 * change the other and both test files.
 *
 * Used only for the live "Key: …" preview in the new-workflow dialog. The value the row
 * actually gets is decided server-side (models/AppWorkflow.model.js), which is the only
 * place that can see which keys are already taken.
 */

const MAX_LENGTH = 64;

export function slugify(input, fallback = 'item') {
  const slug = String(input == null ? '' : input)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    // Collapsing first guarantees at most ONE dash at each boundary, which is what lets the
    // trims below be single-character (a `-+` quantifier here backtracks super-linearly).
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-/, '')
    .replace(/-$/, '')
    .slice(0, MAX_LENGTH)
    .replace(/-$/, '');
  return slug || fallback;
}

export { MAX_LENGTH };
